import { Lang } from "@axl/membership-sdk";
import { useCallback, useMemo } from "react";

import { useLangDetector } from "./useLangDetector";
import { useSchool } from "./useSchool";
import { useSdk } from "./useSdk";
import { useUser } from "./useUser";

type SelectLangOptions = {
  reload?: boolean;
  /**
   * Skip server request
   */
  silent?: boolean;
};

export function useLang() {
  const user = useUser();
  const sdk = useSdk();
  const langDetector = useLangDetector();
  const school = useSchool();

  const lang = useMemo(() => {
    return langDetector.cookieLang || school?.lang;
  }, [langDetector.cookieLang, school?.lang]);

  const selectLang = useCallback(
    async (
      selectedLang: Lang,
      opts: SelectLangOptions = { reload: false, silent: true },
    ) => {
      if (user.isAuthorized && opts.silent !== true)
        await sdk.api.account.selectLang(selectedLang);
      langDetector.setLang(selectedLang);
      window.location.reload();
    },
    [langDetector, sdk.api.account, user.isAuthorized],
  );

  return { lang, selectLang };
}
